import * as React from 'react';
import { cn } from '@noor/lib/cn';

/**
 * A centered date pill separating a day's worth of messages (e.g.
 * "Сегодня, 20 июня"). The label arrives via children — this component holds no
 * domain strings and does no date formatting.
 */
export interface ChatDayDividerProps extends React.ComponentProps<'div'> {
  children: React.ReactNode;
}

function ChatDayDivider({ className, children, ...props }: ChatDayDividerProps) {
  return (
    <div
      data-slot="chat-day-divider"
      className={cn('flex justify-center', className)}
      {...props}
    >
      <span className="rounded-full bg-muted px-3 py-1 text-xs font-medium text-muted-foreground">
        {children}
      </span>
    </div>
  );
}

export { ChatDayDivider };
